export enum DateTimePrecision {
    Milliseconds = 'Milliseconds',
    Seconds = 'Seconds',
}
